"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenubarItemFactoryFromJS = exports.MenubarItemFactory = void 0;
const immutable_1 = require("immutable");
exports.MenubarItemFactory = (0, immutable_1.Record)({
    actionKey: null,
    groupName: null,
    icon: null,
    isAction: false,
    items: (0, immutable_1.List)(),
    key: null,
    selectable: false,
    shortCut: null,
    text: null,
    visibility: true,
    isDivider: false,
    disabled: false
});
const MenubarItemFactoryFromJS = function (data) {
    const items = data.items
        ? data.items.map(function (value) {
            return (0, exports.MenubarItemFactoryFromJS)(value);
        })
        : [];
    return (0, exports.MenubarItemFactory)({
        actionKey: data.actionKey,
        groupName: data.groupName,
        icon: data.icon,
        isAction: data.isAction,
        items: data.items ? (0, immutable_1.List)(items) : null,
        key: data.key,
        selectable: data.selectable,
        shortCut: data.shortCut,
        text: data.text,
        visibility: data.visibility,
        isDivider: data.isDivider,
        disabled: data.disabled
    });
};
exports.MenubarItemFactoryFromJS = MenubarItemFactoryFromJS;
//# sourceMappingURL=IMenubarItem.js.map